export const enum PaymentType {
  CreditCard = 0,
  QRCode = 1,
  PaymentTerm = 2,
  Manual = 3,
}
